import { Injectable, inject } from '@angular/core';
import { HttpService, UrlService } from '@boels/helpers';
import { EMPTY, Observable, map, switchMap, withLatestFrom } from 'rxjs';
import { CultureFacade } from '../../cultures/facade/cultures.facade';
import { BoelsReCaptchaV3Service } from '../../recaptcha/boels-recaptcha.service';
import { SiteContextFacade } from '../../site-context/facade/site-context.facade';

@Injectable({
  providedIn: 'any',
})
export class CreditAccountGateway {
  private urlService = inject(UrlService);
  private siteContextFacade = inject(SiteContextFacade);
  private cultureFacade = inject(CultureFacade);
  private readonly http = inject(HttpService);
  private recaptchaService = inject(BoelsReCaptchaV3Service, {
    optional: true,
  });

  submitForm(formData: any): Observable<any> {
    if (!this.recaptchaService) return EMPTY;
    return this.recaptchaService.execute('creditAccountForm').pipe(
      withLatestFrom(
        this.siteContextFacade.getActiveBaseSiteEntity(),
        this.cultureFacade.getActiveLanguage(),
        this.cultureFacade.getActiveCurrency(),
      ),
      map(([recaptchaToken, baseSiteId, lang, currency]) => ({
        params: [
          ['recaptchaToken', recaptchaToken],
          ['lang', lang],
          ['curr', currency],
        ],
        url: this.urlService.combineUri(
          baseSiteId.uid,
          '/renting-on-account/form',
        ),
      })),
      switchMap(({ url, params }) => this.http.post(url, formData, params)),
    );
  }
}
